// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import VueAxios from './plugins/axios'
import IdleVue from 'idle-vue'
import Loading from 'vue-loading-overlay'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import Notifications from 'vue-notification'
import store from './store'
import 'vue-loading-overlay/dist/vue-loading.css'
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'typeface-roboto/index.css'

Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(VueAxios)
Vue.use(Loading)
Vue.use(Notifications)
Vue.use(IdleVue, {
  eventEmitter: new Vue(),
  store,
  idleTime: 300000, // 5 minutes (ms)
  startAtIdle: false
})
Vue.component('vue-cookie-accept-decline', VueCookieAcceptDecline)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js